var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConferenceTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 37,
    viewBox: "0 0 151 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.5H150.429V9.5H133.714L136.753 36.5H128.612L127.093 21.5H21.2727L19.2096 36.5H11.6122L15.1948 9.5H0V0.5ZM125.573 9.5H22.7922L22.0016 15.5H126.201L125.573 9.5Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceTable);
export default __webpack_public_path__ + "static/media/conference_table.beae57bf7c21bca7092b977b2eab9559.svg";
export { ForwardRef as ReactComponent };